<div class="wrapper-mini text-center auth-form">

    <div class="header">
        <h1>Enter your new password</h1>
        <p>Please enter your new password below</p>
    </div>

    <div class="form-block text-left">
        <label for="new_password">New Password</label>
        <input [type]="show_password ? 'text' : 'password'" name="new_password" data-testid="input-reset-new-password" [(ngModel)]="user_new_password">
    </div>

    <div class="form-block text-left">
        <label for="confirm_password">Confirm Password</label>
        <input [type]="show_password ? 'text' : 'password'" name="confirm_password" data-testid="input-reset-confirm-password" [(ngModel)]="user_confirm_password">
        <p class="text-small text-color-primary pointer"
           data-testid="link-toggle-reset-password-visibility"
           (click)="show_password = !show_password">
                {{ show_password ? 'Hide' : 'Show' }} password
        </p>
    </div>

    <div class="footer">
        <saffron-button 
            text="Update your password"
            data-testid="btn-update-password"
            size="wide" 
            type="primary" 
            [is_loading]="loading"
            [is_disabled]="!user_new_password || user_new_password !== user_confirm_password"
            (click)="reset()">
        </saffron-button>
        <p>
            Go back to 
            <a class="text-color-primary" data-testid="link-back-to-login-from-reset" [routerLink]="['/auth/login']">login</a>
        </p>
    </div>
    
</div>